module.exports = __webpack_public_path__ + "img/317.38e04b97.jpg";